interface IconItem {
	name: string;
	label: string;
}

interface IconCategoriesType {
	Marketing: IconItem[];
	CRM: IconItem[];
	Listings: IconItem[];
	Websites: IconItem[];
	Financial: IconItem[];
	'General / Other': IconItem[];
}

const IconCategories: IconCategoriesType = {
	Marketing: [
		{ name: 'BsMegaphone', label: 'megaphone' },
		{ name: 'BsChatDots', label: 'chat-dots' },
		{ name: 'BsEnvelopePaper', label: 'envelope-paper' },
		{ name: 'BsEnvelopeOpen', label: 'envelope-open' },
		{ name: 'BsPrinter', label: 'printer' },
		{ name: 'BsStars', label: 'stars' },
		{ name: 'BsEasel', label: 'easel' },
		{ name: 'BsCalendarEvent', label: 'calendar-event' },
	],
	CRM: [
		{ name: 'BsPeople', label: 'people' },
		{ name: 'BsPersonLinesFill', label: 'person-lines-fill' },
		{ name: 'BsPersonPlus', label: 'person-plus' },
		{ name: 'BsPersonCheck', label: 'person-check' },
		{ name: 'BsJournalText', label: 'journal-text' },
		{ name: 'BsTags', label: 'tags' },
	],
	Listings: [
		{ name: 'BsHouse', label: 'house' },
		{ name: 'BsHouses', label: 'houses' },
		{ name: 'BsHouseDoor', label: 'house-door' },
		{ name: 'BsGeoAlt', label: 'geo-alt' },
		{ name: 'BsPinMap', label: 'pin-map' },
		{ name: 'BsClipboardCheck', label: 'clipboard-check' },
		{ name: 'BsCamera', label: 'camera' },
	],
	Websites: [
		{ name: 'BsGlobe', label: 'globe' },
		{ name: 'BsWindow', label: 'window' },
		{ name: 'BsCursor', label: 'cursor' },
		{ name: 'BsPencilSquare', label: 'pencil-square' },
		{ name: 'BsFileRichtext', label: 'file-richtext' },
		{ name: 'BsStar', label: 'star' },
		{ name: 'BsLink45Deg', label: 'link-45deg' },
		{ name: 'BsSearch', label: 'search' },
	],
	Financial: [
		{ name: 'BsWallet', label: 'wallet' },
		{ name: 'BsCash', label: 'cash' },
		{ name: 'BsCashStack', label: 'cash-stack' },
		{ name: 'BsCurrencyDollar', label: 'currency-dollar' },
		{ name: 'BsFileEarmarkText', label: 'file-earmark-text' },
		{ name: 'BsFileEarmarkPlus', label: 'file-earmark-plus' },
		{ name: 'BsCreditCard', label: 'credit-card' },
		{ name: 'BsReceipt', label: 'receipt' },
		{ name: 'BsGraphUp', label: 'graph-up' },
		{ name: 'BsBarChart', label: 'bar-chart' },
	],
	'General / Other': [
		{ name: 'BsGear', label: 'gear' },
		{ name: 'BsCloudArrowDown', label: 'cloud-arrow-down' },
		{ name: 'BsCheckCircle', label: 'check-circle' },
		{ name: 'BsBoxArrowUpRight', label: 'box-arrow-up-right' },
	],
};

export default IconCategories;
